import React from "react";

const AppContext = React.createContext({formSavedStatus : null});

export default AppContext;